<template>
  <BasePageContainer class="page group_add pt-3">
    <div class="page__head group_add-head fixed-top p-3">
      <h1 class="group_add-head__heading">
        <router-link
          to="/admin/groups/"
          class="group_add-head__back">
          <span class="material-icons">
            arrow_back_ios
          </span>
        </router-link>
        グループ追加
      </h1>
    </div>
    <div class="group_add__body general-form pt-8">
      <form>
        <validation-observer v-slot="observer">
          <div class="general-form__group form-group row">
            <label
              class="col-4 col-form-label">名前</label>
            <div class="col-8">
              <validation-provider
                v-slot="v"
                name="名前"
                rules="required|max:50">
                <b-form-input
                  v-model="groupName"
                  type="text"
                  data-testid="group-name-input"
                  hide-header />
                <p class="text-primary">
                  {{ v.errors[0] }}
                </p>
              </validation-provider>
            </div>
          </div>
          <div class="general-form__group form-group row">
            <label
              class="col-4 col-form-label">表示優先度</label>
            <div class="col-8">
              <validation-provider
                v-slot="v"
                name="表示優先度"
                rules="required">
                <b-form-input
                  v-model="sortNo"
                  type="number"
                  data-testid="group-sort-input"
                  hide-header />
                <p class="text-primary">
                  {{ v.errors[0] }}
                </p>
              </validation-provider>
            </div>
          </div>
          <div class="general-form__btn row mt-5">
            <div class="col-6 offset-6">
              <button
                type="button"
                class="btn btn-block btn-primary"
                @click="observer.passes(onClickSave)">
                作成
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </BasePageContainer>
</template>

<script>
export default {
  data() {
    return {
      groupName: '',
      sortNo: 0
    }
  },
  methods: {
    onClickSave(){
      this.$store.commit('startLoading')
      const params = {
        name: this.groupName,
        sortNo: this.sortNo
      }

      this.$axios.post('/departments/', params).then(() => {
        this.$store.commit('notify/set', {message: 'グループを作成しました。'})
      }).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
        this.$router.push('/admin/groups/')
      })

    },
    onClickCancel(){
      this.$router.push('/admin/groups/')
    }
  }

}
</script>

<style lang="scss" scoped>
.group_add-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    right: 0;
    left: 120px;
  }
  &__back{
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}
.group_add{
  &__head{
    background-color: $primary;
    color: $white;
    border-radius: 8px;
  }
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
    
  }
  &__name{
    font-weight: bold;
  }
  &__title{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}

.form-info{
  color: $grey09;
  &__logout{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
}
</style>